(function() {
  'use strict';

  var CONFIG = {
    freeShippingThreshold: 2999,
    discountCode: 'OFF15TL',
    socialProofMin: 8,
    socialProofMax: 24,
    exitIntentCooldown: 'tl_exit_shown'
  };

  function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function isProductPage() {
    return document.body.classList.contains('template-product') ||
           window.location.pathname.includes('/products/');
  }

  function isCartPage() {
    return document.body.classList.contains('template-cart') ||
           window.location.pathname === '/cart';
  }

  function isCollectionPage() {
    return document.body.classList.contains('template-collection') ||
           window.location.pathname.includes('/collections/');
  }

  /* ── SOCIAL PROOF TICKER ───────────────────────────────────── */
  function initSocialProof() {
    if (!isProductPage()) return;
    var priceBlock = document.querySelector('.product__price, .price-wrapper, .product-single__price, [class*="product__price"]');
    if (!priceBlock) return;
    if (document.querySelector('.tl-social-proof')) return;
    var count = randomInt(CONFIG.socialProofMin, CONFIG.socialProofMax);
    var el = document.createElement('div');
    el.className = 'tl-social-proof';
    el.innerHTML = '<div class="tl-dot"></div><span><strong>' + count + ' people</strong> are viewing this right now</span>';
    priceBlock.parentNode.insertBefore(el, priceBlock.nextSibling);
    setInterval(function() {
      var strong = el.querySelector('strong');
      if (strong) strong.textContent = randomInt(CONFIG.socialProofMin, CONFIG.socialProofMax) + ' people';
    }, randomInt(30000, 60000));
  }

  /* ── SAVINGS CALLOUT ───────────────────────────────────────── */
  function initSavingsCallout() {
    if (!isProductPage()) return;
    if (document.querySelector('.tl-savings-pill')) return;
    var salePriceEl = document.querySelector('.price--on-sale .price-item--sale, .price-item.price-item--sale');
    var comparePriceEl = document.querySelector('.price-item--compare, .price-item.price-item--compare');
    if (!salePriceEl || !comparePriceEl) return;
    var sale = parseInt(salePriceEl.textContent.replace(/[^\d]/g, ''));
    var compare = parseInt(comparePriceEl.textContent.replace(/[^\d]/g, ''));
    var saving = compare - sale;
    if (saving > 0) {
      var pill = document.createElement('span');
      pill.className = 'tl-savings-pill';
      pill.textContent = 'You save Rs.' + saving.toLocaleString('en-PK') + '!';
      salePriceEl.parentNode.appendChild(pill);
    }
  }

  /* ── STICKY MOBILE ATC BAR ─────────────────────────────────── */
  function initStickyMobileATC() {
    if (!isProductPage()) return;
    if (window.innerWidth > 768) return;
    if (document.querySelector('.tl-sticky-mobile-bar')) return;
    var originalBtn = document.querySelector('.product-form__submit, button[name="add"]');
    if (!originalBtn) return;
    var priceEl = document.querySelector('.price--on-sale .price-item--sale, .price__regular .price-item--regular, .price-item');
    var compareEl = document.querySelector('.price-item--compare');
    var bar = document.createElement('div');
    bar.className = 'tl-sticky-mobile-bar';
    bar.innerHTML = '<div class="tl-sticky-price">' +
      (priceEl ? priceEl.textContent.trim() : '') +
      (compareEl ? '<s>' + compareEl.textContent.trim() + '</s>' : '') +
      '</div><button class="tl-sticky-btn">Add to Cart</button>';
    document.body.appendChild(bar);
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('tl-visible');
        } else {
          bar.classList.add('tl-visible');
        }
      });
    }, { threshold: 0.1 });
    observer.observe(originalBtn);
    bar.querySelector('.tl-sticky-btn').addEventListener('click', function() {
      originalBtn.click();
      var form = originalBtn.closest('form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ── FREE SHIPPING BAR (cart) ──────────────────────────────── */
  function initShippingBar() {
    if (!isCartPage()) return;
    if (document.querySelector('.tl-shipping-bar')) return;
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = cart.total_price / 100;
        var threshold = CONFIG.freeShippingThreshold;
        var remaining = Math.max(0, threshold - total);
        var pct = Math.min(100, Math.round((total / threshold) * 100));
        var cartForm = document.querySelector('form[action="/cart"], .cart__form, .cart-form, #cart-form');
        if (!cartForm) return;
        var bar = document.createElement('div');
        bar.className = 'tl-shipping-bar';
        if (remaining <= 0) {
          bar.innerHTML = '<div class="tl-shipping-label"><span>🎉 You have unlocked FREE delivery!</span><span>🚚</span></div><div class="tl-shipping-track"><div class="tl-shipping-fill" style="width:100%"></div></div>';
        } else {
          bar.innerHTML = '<div class="tl-shipping-label"><span>Add Rs.' + Math.round(remaining).toLocaleString('en-PK') + ' more for FREE delivery!</span><span>🚚</span></div><div class="tl-shipping-track"><div class="tl-shipping-fill" style="width:' + pct + '%"></div></div><div class="tl-shipping-msg">Free delivery on orders above Rs.2,999</div>';
        }
        cartForm.parentNode.insertBefore(bar, cartForm);
      })
      .catch(function() {});
  }

  /* ── CART UPSELL WIDGET ────────────────────────────────────── */
  function initCartUpsell() {
    if (!isCartPage()) return;
    if (document.querySelector('.tl-upsell-strip')) return;
    var upsells = [
      { title: 'UNO Classic Card Game', price: 'Rs.795', handle: 'uno-classic-card-game' },
      { title: 'Jenga Classic 54-Piece', price: 'Rs.4,495', handle: 'jenga-game-wooden-blocks' },
      { title: 'Moon Ball Glow Toy', price: 'Rs.495', handle: 'super-high-bouncing-space-moon-ball' },
      { title: 'Pokemon Cards Booster', price: 'Rs.150+', handle: 'pokemon-cards-scarlet-violet' },
      { title: 'Reversible Octopus Plush', price: 'Rs.950', handle: 'reversible-octopus-plush-toy' },
      { title: 'UNO No Mercy Edition', price: 'Rs.1,295', handle: 'uno-no-mercy-card-game' }
    ];
    var cartEl = document.querySelector('.cart__items, .cart-items, #cart-form');
    if (!cartEl) return;
    var html = '';
    upsells.forEach(function(p) {
      html += '<div class="tl-upsell-product" onclick="window.location=\'/products/' + p.handle + '\'">' +
        '<div class="tl-upsell-info"><div class="tl-upsell-name">' + p.title + '</div>' +
        '<div class="tl-upsell-price">' + p.price + '</div></div>' +
        '<button class="tl-upsell-add" onclick="event.stopPropagation();window.location=\'/products/' + p.handle + '\'">View</button></div>';
    });
    var widget = document.createElement('div');
    widget.className = 'tl-upsell-strip';
    widget.innerHTML = '<div class="tl-upsell-title">⚡ Customers also bought</div><div class="tl-upsell-products">' + html + '</div>';
    cartEl.parentNode.insertBefore(widget, cartEl.nextSibling);
  }

  /* ── EXIT INTENT POPUP (desktop only) ─────────────────────── */
  function initExitIntent() {
    if (window.innerWidth < 769) return;
    if (isCartPage()) return;
    if (document.getElementById('tl-exit-popup')) return;
    try { if (sessionStorage.getItem(CONFIG.exitIntentCooldown)) return; } catch(e) {}
    var overlay = document.createElement('div');
    overlay.className = 'tl-exit-overlay';
    overlay.id = 'tl-exit-popup';
    overlay.innerHTML = '<div class="tl-exit-popup">' +
      '<button class="tl-exit-close" id="tl-exit-close">&#215;</button>' +
      '<div class="tl-exit-emoji">&#127873;</div>' +
      '<div class="tl-exit-headline">Wait! Before you go...</div>' +
      '<div class="tl-exit-sub">Get <strong>15% OFF</strong> your entire order. Copy this code and use it at checkout!</div>' +
      '<div class="tl-exit-code" id="tl-copy-code">OFF15TL<div class="tl-exit-copy-tip">Click to copy</div></div>' +
      '<button class="tl-exit-btn" id="tl-exit-shop">Shop Now — 15% OFF</button>' +
      '<button class="tl-exit-dismiss" id="tl-exit-dismiss">No thanks, I will pay full price</button>' +
      '</div>';
    document.body.appendChild(overlay);
    var triggered = false;
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 10 && !triggered) {
        triggered = true;
        setTimeout(function() {
          overlay.classList.add('tl-show');
          try { sessionStorage.setItem(CONFIG.exitIntentCooldown, '1'); } catch(e) {}
        }, 300);
      }
    });
    document.getElementById('tl-copy-code').addEventListener('click', function() {
      try { navigator.clipboard.writeText('OFF15TL'); } catch(e) {}
      var el = document.getElementById('tl-copy-code');
      el.innerHTML = '&#10003; Copied! Use at checkout';
      setTimeout(function() {
        el.innerHTML = 'OFF15TL<div class="tl-exit-copy-tip">Click to copy</div>';
      }, 2000);
    });
    document.getElementById('tl-exit-shop').addEventListener('click', function() {
      window.location = '/discount/OFF15TL?redirect=/collections/all';
    });
    document.getElementById('tl-exit-close').addEventListener('click', function() {
      overlay.classList.remove('tl-show');
    });
    document.getElementById('tl-exit-dismiss').addEventListener('click', function() {
      overlay.classList.remove('tl-show');
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) overlay.classList.remove('tl-show');
    });
  }

  /* ── TOAST NOTIFICATION ────────────────────────────────────── */
  function showToast(message, duration) {
    duration = duration || 3000;
    var existing = document.getElementById('tl-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.id = 'tl-toast';
    toast.style.cssText = 'position:fixed;bottom:80px;left:50%;transform:translateX(-50%);background:#1A1A2E;color:#fff;padding:12px 20px;border-radius:10px;font-size:13px;font-weight:600;z-index:99999;box-shadow:0 4px 20px rgba(0,0,0,0.3);white-space:nowrap;max-width:90vw;text-align:center;';
    toast.textContent = message;
    document.body.appendChild(toast);
    setTimeout(function() { if (toast.parentNode) toast.remove(); }, duration);
  }

  /* ── ATC FEEDBACK TOAST ────────────────────────────────────── */
  function initATCFeedback() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('button[name="add"], .btn-addtocart, .product-form__submit');
      if (!btn || btn.disabled) return;
      setTimeout(function() {
        var titleEl = document.querySelector('.product__title h1, .product-single__title, h1.title');
        var title = titleEl ? titleEl.textContent.trim().substring(0, 30) : 'Item';
        showToast('Added to cart: ' + title);
      }, 600);
    });
  }

  /* ── BESTSELLER BADGES ─────────────────────────────────────── */
  function initBestsellerBadges() {
    if (!isCollectionPage() && !document.querySelector('.featured-collection')) return;
    var bestsellers = [
      'classic-glock-soft-bullet-toy-gun',
      'cute-dancing-talking-cactus-toy',
      'supreme-the-cash-cannon-money-gun-toy',
      'pakistan-international-airlines-pia-aircraft',
      'automatic-water-bubble-gun',
      'pop-it-fidget-toy'
    ];
    bestsellers.forEach(function(handle) {
      var link = document.querySelector('a[href*="' + handle + '"]');
      if (!link) return;
      var card = link.closest('.product-item, .card-wrapper');
      if (!card || card.querySelector('.tl-bestseller')) return;
      var badge = document.createElement('div');
      badge.className = 'tl-bestseller';
      badge.style.cssText = 'position:absolute;top:8px;left:8px;background:linear-gradient(135deg,#FFB703,#FB8500);color:#1A1A2E;font-size:10px;font-weight:800;padding:3px 8px;border-radius:6px;text-transform:uppercase;letter-spacing:0.05em;z-index:5;box-shadow:0 2px 6px rgba(251,133,0,0.35);pointer-events:none;';
      badge.textContent = 'Bestseller';
      var mediaEl = card.querySelector('.card-media, .media, .card__media');
      if (mediaEl) {
        mediaEl.style.position = 'relative';
        mediaEl.appendChild(badge);
      }
    });
  }

  /* ── INIT ──────────────────────────────────────────────────── */
  function init() {
    initSocialProof();
    initSavingsCallout();
    initStickyMobileATC();
    initATCFeedback();
    initShippingBar();
    initCartUpsell();
    initExitIntent();
    initBestsellerBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(init, 100);
  });

})();